/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetTikTokCreatorInfoQueryResponse, SocialExportGetTikTokCreatorInfoPathParams, SocialExportGetTikTokCreatorInfo400, SocialExportGetTikTokCreatorInfo401, SocialExportGetTikTokCreatorInfo403, SocialExportGetTikTokCreatorInfo404 } from "../models/SocialExportGetTikTokCreatorInfo";

export function getSocialExportGetTikTokCreatorInfoUrl(connectionId: SocialExportGetTikTokCreatorInfoPathParams["connectionId"]) {
  const res = { method: 'GET', url: `/social-export/v1/platforms/tiktok/${connectionId}/creator-info` as const }
  return res
}

/**
 * @description Returns TikTok creator profile and permission info (privacy options, comment/duet/stitch settings, max video duration). Use when rendering the Post to TikTok page per Content Sharing Guidelines.
 * @summary Get TikTok creator info for a connection
 * {@link /social-export/v1/platforms/tiktok/:connectionId/creator-info}
 */
export async function socialExportGetTikTokCreatorInfo(connectionId: SocialExportGetTikTokCreatorInfoPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<SocialExportGetTikTokCreatorInfo400 | SocialExportGetTikTokCreatorInfo401 | SocialExportGetTikTokCreatorInfo403 | SocialExportGetTikTokCreatorInfo404>, unknown>({ method : "GET", url : getSocialExportGetTikTokCreatorInfoUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}